import { Component, computed, inject } from '@angular/core';
import { ShoppingCartService } from '../../../../frontend/shopping-cart/shopping-cart.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { MatBadgeModule } from '@angular/material/badge';
import { i18nRouterLinkDirective } from '../../../router/i18n-router-link.directive';

@Component({
  selector: 'app-shopping-cart-icon',
  templateUrl: './shopping-cart-icon.component.html',
  standalone: true,
  imports: [SvgIconComponent, MatBadgeModule, i18nRouterLinkDirective],
})
export class ShoppingCartIconComponent {
  private readonly shoppingCart = inject(ShoppingCartService);
  itemCount = computed(() => this.shoppingCart.cart().registrations.length);
}
